import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { RolloutProgressReportEntities } from '../../entities';

const spanProgressApiUrlV3 = environment.spanProgressApiUrlV3;

@Injectable({
  providedIn: 'root',
})
export class RolloutProgressReportDefinitionsApiService {
  constructor(private http: HttpClient) {}

  getDefinitions(pointType: RolloutProgressReportEntities.v3.MarkerTypes) {
    return this.http.get<RolloutProgressReportEntities.v3.DefinitionsWithGroupInfoResponse>(
      `${spanProgressApiUrlV3}/self-inspection-definitions?pointType=${pointType}`,
    );
  }
}
